var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagefooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0955 7.92808L9.15247 10.3925L5.2094 7.92808V6.94231L9.15247 9.40673L13.0955 6.94231V7.92808ZM13.0955 5.95654H5.2094C4.6623 5.95654 4.22363 6.39521 4.22363 6.94231V12.8569C4.22363 13.1184 4.32749 13.3691 4.51236 13.554C4.69722 13.7388 4.94796 13.8427 5.2094 13.8427H13.0955C13.357 13.8427 13.6077 13.7388 13.7926 13.554C13.9774 13.3691 14.0813 13.1184 14.0813 12.8569V6.94231C14.0813 6.39521 13.6377 5.95654 13.0955 5.95654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagefooter);
export default __webpack_public_path__ + "static/media/messagefooter.5242f32488401bd8238c1670f2a51bbf.svg";
export { ForwardRef as ReactComponent };